/*
import React from 'react';
import { useHistory } from 'react-router-dom'; 
import { Box, Button, Typography } from '@mui/material';
*/
import React, { useState } from 'react';
import { Box, Button, Dialog, DialogTitle, DialogContent, TextField, DialogActions } from '@mui/material';
import axios from 'axios';
import { useHistory } from 'react-router-dom'; 

function Page2SubPageB() {
  const history = useHistory(); 

  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async () => {
    try {
      await axios.post('/api/govPosts', {
        title,
        content,
        topic: 'page2subpaged' // this allows you to filter it in Page2SubPageD
      });
      setOpen(false);
      setTitle('');
      setContent('');
      alert('Post created!');
    } catch (err) {
      console.error('Failed to create post', err);
    }
  };

  return (
    <div
            style={{
                padding: '20px',
                backgroundColor: '#FFFDF8',
                minHeight: '100vh',  // ensures it covers the full viewport height
                boxSizing: 'border-box', // ensures padding doesn't affect layout
            }}
        >

            <div style={{ width: '200px' }}></div>

            {/* Centered Buttons */}
            <Box
                display="flex"
                justifyContent="center"
                alignItems="center"
                gap={2}
                flexWrap="wrap"
                sx={{
                    mt: 4,
                    mb: 4,
                }}
                    >
                      <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b1')}
                    >
                        Enacted Laws
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/b/b2')}
                    >
                        U.S. Congressional Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push('/page2/CaliforniaBills')}
                    >
                        California Legislature Bills
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => history.push(`/page2/CaliforniaPropositions`)}
                    >
                        State Propositions
                    </Button>
                    <Button
                        variant="outlined"
                        sx={{
                            padding: "6px 12px",
                            borderColor: "#333333",  
                            color: "#333333",       
                            backgroundColor: "transparent",
                            '&:hover': {
                                borderColor: "black",
                                color: "black",
                                backgroundColor: "rgba(0, 0, 0, 0.04)", // subtle hover background
                            },
                        }}
                        onClick={() => setOpen(true)}
                    >
                        Propose
                    </Button>
                    {/*
        <Button variant="contained" onClick={() => history.push('/page2/b/b1')}>
          Enacted Laws
        </Button>
        <Button variant="contained" onClick={() => history.push('/page2/b/b2')}>
          Bills
        </Button>
        */}
        {/*Button variant="contained" onClick={() => history.push('/page2/b/b3')}>*/}
         {/* Propose */}
        {/*</Button>*/}
        {/* Create Post Button */}
        {/*
        <Button variant="contained" onClick={() => setOpen(true)}>
          Propose
        </Button>
        */}

        {/* Dialog for Creating Post */}
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>Propose a law or government action or reformation to an existing law, bill, or government action</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Post Title"
              fullWidth
              placeholder="Title of Proposal"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
            <TextField
              margin="dense"
              label="Post Content"
              fullWidth
              placeholder="Write"
              multiline
              minRows={4}
              value={content}
              onChange={(e) => setContent(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={handleSubmit} variant="contained">Submit</Button>
          </DialogActions>
        </Dialog>   
      </Box>
    </div>
  );
}

export default Page2SubPageB;


/*
import React from 'react';
import { Box, Typography } from '@mui/material';

function Page2SubPageB() {
  return (
    <Box p={4}>
      <Typography variant="h4">Law</Typography>
    </Box>
  );
}

export default Page2SubPageB;
*/